import Oidc, { WebStorageStateStore, WebStorageStateStoreSettings } from 'oidc-client';
import * as Constants from '@/utils/constants';

const stagingAuthority = Constants.STAGING_AUTHORITY;
const wsSettings: WebStorageStateStoreSettings = {};

export const authManager = new Oidc.UserManager({
  userStore: new WebStorageStateStore(wsSettings),
  authority: stagingAuthority,
  client_id: Constants.CLIENT_ID,
  redirect_uri: Constants.REDIRECT_URI,
  response_type: 'id_token token',
  scope: 'openid profile all_claims',
  post_logout_redirect_uri: Constants.POST_LOGOUT_REDIREC_URI,
  loadUserInfo: true,
});

export let userObj: any;
export let signedIn = false;
const mgr = authManager;

export const signIn = () => {
  mgr.signinRedirect().catch((err) => {
    console.log(err);
  });
};

export const signOut = () => {
//   var self = this;
  mgr.signoutRedirect().then((resp) => {
    signedIn = false;
    console.log('signed out', resp);
  }).catch((err) => {
    console.log(err);
  });
};
